module.exports = __webpack_public_path__ + "static/media/404.1a40dfcb.png";